import { Modal } from 'react-bootstrap';
const CropImageModal = ({ show,
    handleClose,
    initializeCropper,
    cropperImageRef,
    originalImage,
    handleCrop
}) => {
    return (

        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            onShow={initializeCropper}
            className='dark_common_modal'
        >
            <Modal.Header closeButton>
                <Modal.Title>Crop Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ maxWidth: '100%', overflow: 'hidden', textAlign: 'center' }}>
                    <img id="croppedImage"
                        ref={cropperImageRef}
                        src={originalImage}
                        className="croppedImage" alt="Image to crop"
                        style={{
                            maxWidth: '100%',
                            // maxHeight: '500px', // Limit height to prevent oversizing
                            // objectFit: 'contain',
                        }} />


                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn common-btn commonGoldBtn" type='button' onClick={handleCrop}>
                    Crop & Upload
                </button>
            </Modal.Footer>
        </Modal >
    )
}
export default CropImageModal